<template>
  <div
    class="iqa-auth-background box-border flex items-center justify-center"
    :class="{ 'iqa-theme-industrial': menuColorTheme.key === 'industrial' }"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
const { theme: menuColorTheme } = useMenuColorTheme()
</script>

<style></style>
